import React from 'react'

import AboutBody from './AboutBody'
import GetInvolvedBody from './GetInvolvedBody'
import HeroBanner from './HeroBanner'
import InspirationalQuote from './InspirationalQuote'
import MaterialsBody from './MaterialsBody'
import NewsBody from './NewsBody'
import OutreachBody from '../../containers/OutreachBody'
import Section from './Section'
import sectionConfig from '../../configs/section-config'

const _bodyMap = {
  about: AboutBody,
  outreach: OutreachBody,
  materials: MaterialsBody,
  news: NewsBody,
  getInvolved: GetInvolvedBody
};


const Home = () => {
  const sections = Object.keys(sectionConfig).filter(key => !sectionConfig[key].omitInSections).map(key => {
    const body = _bodyMap[key];
    return (
      <Section {...sectionConfig[key]} key={key} body={body}/>
    );
  });

  return (
    <div className="home">
      <section className="hero">
        <HeroBanner />
        <InspirationalQuote />
      </section>
      {sections}
    </div>
  );
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js